import { Component, Input, OnChanges } from '@angular/core';
import { AvailableLanguages } from '@constants';
import { HighlightBand, Product } from '@interfaces';

@Component({
  selector: 'app-upsell-card',
  templateUrl: './upsell-card.component.html',
  styleUrls: ['./upsell-card.component.scss'],
  standalone: false,
})
export class UpsellCardComponent implements OnChanges {
  @Input({ required: true }) product: Partial<Product>;
  @Input({ required: true }) lang: AvailableLanguages;

  public bands: HighlightBand[] = [];
  public fullDescriptionText = '';
  public benefits: string[] = [];

  ngOnChanges(): void {
    const bands = Array.isArray(this.product.highlightBands) ? this.product.highlightBands : [];
    this.bands = this.product.showHighlightBands ? [...bands].sort((a, b) => a.positionIndex - b.positionIndex) : [];

    // each <li> becomes a checkmark item, anything outside lists is rendered as a paragraph
    const doc = new DOMParser().parseFromString(this.product.fullDescription?.[this.lang] || '', 'text/html');
    this.benefits = Array.from(doc.body.querySelectorAll('li')).map(li => li.innerHTML);
    doc.body.querySelectorAll('ul, ol').forEach(list => list.remove());
    this.fullDescriptionText = doc.body.innerHTML.trim();
  }
}
